<div class="hit-list-root">

  <!-- Controls bar -->
  <div class="hl-controls">
    <label class="hl-days-label">
      Last
      <input class="hl-days-input" type="number" min="1" max="365" [(ngModel)]="daysInput" />
      days
    </label>
    <label class="hl-search-label">
      Search
      <input class="hl-search-input" type="search" placeholder="Opponent or alliance" [(ngModel)]="searchTerm" />
    </label>
    <label class="hl-search-label">
      Star value
      <span class="hl-star-range">
        <input class="hl-star-input" type="number" min="0" placeholder="min" [(ngModel)]="starValueMin" />
        <span class="hl-star-range-sep">-</span>
        <input class="hl-star-input" type="number" min="0" placeholder="max" [(ngModel)]="starValueMax" />
      </span>
    </label>
    <label class="hl-hide-completed-label">
      <input type="checkbox" [(ngModel)]="hideCompleted" />
      Hide completed
    </label>
    <button class="hl-apply-btn" type="button" (click)="loadHitList()" [disabled]="loading">
      Apply
    </button>
    <span class="hl-count" *ngIf="!loading">
      <ng-container *ngIf="searchTerm || starValueMin != null || starValueMax != null; else totalCount">
        {{ filteredTargets.length }} / {{ targets.length }} result{{ filteredTargets.length !== 1 ? 's' : '' }}
      </ng-container>
      <ng-template #totalCount>{{ targets.length }} target{{ targets.length !== 1 ? 's' : '' }}</ng-template>
    </span>
    <span class="spinner hl-spinner" *ngIf="loading"></span>
    <button class="hl-newtab-btn" type="button" (click)="openInNewTab()" *ngIf="isModalMode" title="Open in new tab">
      ↗ New Tab
    </button>
  </div>

  <!-- Error -->
  <div class="error-msg" *ngIf="error && !loading">{{ error }}</div>

  <!-- Loading state -->
  <div class="hl-loading" *ngIf="loading">
    <div class="spinner-lg"></div>
    <span>Building hit list…</span>
  </div>

  <!-- Empty state -->
  <div class="hl-empty" *ngIf="!loading && !error && filteredTargets.length === 0">
    <ng-container *ngIf="searchTerm || starValueMin != null || starValueMax != null; else noOpponents">
      No hit list targets match your filter.
    </ng-container>
    <ng-template #noOpponents>
      No opponents you've beaten in the last {{ daysInput }} days.
    </ng-template>
  </div>

  <!-- Table -->
  <div class="hl-table-wrap" *ngIf="!loading && targets.length > 0">
    <table class="hl-table">
      <thead>
        <tr>
          <th class="hl-col-completed"></th>
          <th class="hl-col-name"  (click)="sort('opponentName')">Opponent{{ sortIndicator('opponentName') }}</th>
          <th class="hl-col-troph" (click)="sort('trophies')">
            Trophies{{ sortIndicator('trophies') }}
            <span class="hl-loading-dot" *ngIf="detailsLoading" title="Loading live trophy data…">…</span>
          </th>
          <th class="hl-col-score" title="Current tournament stars (live from PSS if available, otherwise snapshot)">Current Stars</th>
          <th class="hl-col-stars" title="Star value = max(floor(prior day stars * 0.15), floor(trophies / 1000))" (click)="sort('stars')">Star value{{ sortIndicator('stars') }}</th>
          <th class="hl-col-wins"  (click)="sort('winCount')">Wins{{ sortIndicator('winCount') }}</th>
          <th class="hl-col-loss"  (click)="sort('lossCount')">Losses{{ sortIndicator('lossCount') }}</th>
          <th class="hl-col-ratio" (click)="sort('winRatio')">Win%{{ sortIndicator('winRatio') }}</th>
          <th class="hl-col-date"  (click)="sort('lastWinDate')">Last Win{{ sortIndicator('lastWinDate') }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let t of filteredTargets">

          <!-- ── Summary row ── -->
          <tr class="hl-row"
              [class.hl-row-expanded]="expandedOpponentId === t.opponentId"
              [class.hl-row-completed]="t.isCompleted"
              [class.hl-row-danger]="hasLostMoreThanWon(t)"
              [class.hl-row-warning]="hasMixedResults(t)"
              (click)="toggleExpanded(t)"
              title="Click to see individual battles">

            <td class="hl-col-completed">
              <input type="checkbox"
                     [(ngModel)]="t.isCompleted"
                     (click)="$event.stopPropagation()"
                     (ngModelChange)="saveNote(t)"
                     title="Mark row as completed" />
            </td>

            <!-- Opponent name (with favourite star) -->
            <td class="hl-col-name">
              <div class="hl-name-row">
                <button class="hl-fav-btn"
                        [class.hl-fav-on]="t.isFavorite"
                        (click)="toggleFavorite(t, $event)"
                        [title]="t.isFavorite ? 'Remove from favourites' : 'Add to favourites'">★</button>
                <button class="hl-remove-btn"
                        *ngIf="hasHitListNote(t)"
                        (click)="removeFromHitList(t, $event)"
                        title="Remove from hit list">−</button>
                <div class="hl-name-content">
                  <div class="hl-opponent-name">
                    <span class="hl-chevron">{{ expandedOpponentId === t.opponentId ? '▾' : '▸' }}</span>
                    {{ t.opponentName || ('User ' + t.opponentId) }}
                  </div>
                  <div class="hl-opponent-fleet" *ngIf="t.opponentAlliance">{{ t.opponentAlliance }}</div>
                </div>
              </div>
            </td>

            <!-- Trophies: live from PSS at load time, D1 snapshot as fallback -->
            <td class="hl-col-troph">
              <ng-container *ngIf="t.currentTrophies != null; else trophyFallback">
                {{ t.currentTrophies | number }}
              </ng-container>
              <ng-template #trophyFallback>
                <ng-container *ngIf="t.snapshotTrophies != null; else trophyPending">
                  {{ t.snapshotTrophies | number }}
                  <span class="hl-snap-date" title="Snapshot date: {{ t.lastSnapshotDate }}">*</span>
                </ng-container>
                <ng-template #trophyPending>
                  <span class="hl-cell-muted">—</span>
                </ng-template>
              </ng-template>
            </td>

            <!-- Current tournament stars -->
            <td class="hl-col-score">
              <ng-container *ngIf="currentStars(t) != null; else starsFallback">
                {{ currentStars(t) | number }}
              </ng-container>
              <ng-template #starsFallback>
                <ng-container *ngIf="t.snapshotTournamentStars != null; else starsPending">
                  {{ t.snapshotTournamentStars | number }}
                  <span class="hl-snap-date" title="Snapshot date: {{ t.lastSnapshotDate }}">*</span>
                </ng-container>
                <ng-template #starsPending>
                  <span class="hl-cell-muted">—</span>
                </ng-template>
              </ng-template>
            </td>

            <!-- Star value -->
            <td class="hl-col-stars">
              <ng-container *ngIf="starValue(t) != null; else starValuePending">
                {{ starValue(t) | number }}
              </ng-container>
              <ng-template #starValuePending>
                <span class="hl-cell-muted">—</span>
              </ng-template>
            </td>

            <!-- Wins (with ATK/DEF breakdown) -->
            <td class="hl-col-wins">
              <span class="hl-win-count">{{ t.winCount }}</span>
              <span class="hl-win-detail" *ngIf="t.attackWins > 0 || t.defenseWins > 0">
                <span class="hl-badge-atk" *ngIf="t.attackWins > 0" title="Attack wins">{{ t.attackWins }}A</span>
                <span class="hl-badge-def" *ngIf="t.defenseWins > 0" title="Defense wins">{{ t.defenseWins }}D</span>
              </span>
            </td>

            <!-- Losses -->
            <td class="hl-col-loss">{{ t.lossCount || '—' }}</td>

            <!-- Win% -->
            <td class="hl-col-ratio">{{ winRatioLabel(t) }}</td>

            <!-- Last win date -->
            <td class="hl-col-date">{{ formatDate(t.lastWinDate) }}</td>
          </tr>

          <!-- ── Expanded detail row ── -->
          <tr *ngIf="expandedOpponentId === t.opponentId" class="hl-detail-row">
            <td colspan="9">

              <!-- Notes panel -->
              <div class="hl-notes-panel">
                <div class="hl-notes-fields">
                  <label class="hl-note-field">
                    <span class="hl-note-label">My HP</span>
                    <input type="number" min="0" class="hl-note-input"
                           [(ngModel)]="t.myHpRemaining" placeholder="—" />
                  </label>
                  <label class="hl-note-field">
                    <span class="hl-note-label">Opp HP</span>
                    <input type="number" min="0" class="hl-note-input"
                           [(ngModel)]="t.opponentHpRemaining" placeholder="—" />
                  </label>
                  <label class="hl-note-field hl-note-field-wide">
                    <span class="hl-note-label">Notes</span>
                    <textarea class="hl-note-textarea" rows="2" maxlength="1000"
                              [(ngModel)]="t.notes" placeholder="Add notes…"></textarea>
                  </label>
                </div>

                <div class="hl-notes-actions">
                  <label class="hl-done-label">
                    <input type="checkbox" [(ngModel)]="t.isCompleted" (ngModelChange)="saveNote(t)" />
                    <span>Completed</span>
                  </label>
                  <button class="hl-save-btn" type="button"
                          (click)="saveNote(t)"
                          [disabled]="noteSaving[t.opponentId]">
                    {{ noteSaving[t.opponentId] ? 'Saving…' : 'Save' }}
                  </button>
                  <span class="hl-save-ok"  *ngIf="noteSaveOk[t.opponentId]">✓ Saved</span>
                  <span class="hl-save-err" *ngIf="noteSaveError[t.opponentId]">{{ noteSaveError[t.opponentId] }}</span>
                </div>
              </div>

              <!-- Battle history sub-table -->
              <table class="hl-battles-table">
                <thead>
                  <tr>
                    <th>Role</th>
                    <th>Result</th>
                    <th>Type</th>
                    <th>Trophies</th>
                    <th>Stars</th>
                    <th>League</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let b of t.battles"
                      [class.hl-b-win]="b.won"
                      [class.hl-b-loss]="!b.won && !b.isDraw"
                      [class.hl-b-draw]="b.isDraw">
                    <td>
                      <span class="hl-role-badge" [class.hl-role-atk]="b.role === 'attack'" [class.hl-role-def]="b.role === 'defense'">
                        {{ b.role === 'attack' ? 'ATK' : 'DEF' }}
                      </span>
                    </td>
                    <td class="hl-b-result">{{ battleResultLabel(b) }}</td>
                    <td>{{ b.isStarBattle ? '★ Star' : 'PVP' }}</td>
                    <td [class.hl-trophy-pos]="b.trophyChange > 0" [class.hl-trophy-neg]="b.trophyChange < 0">
                      {{ b.trophyChange > 0 ? '+' : '' }}{{ b.trophyChange !== 0 ? b.trophyChange : '—' }}
                    </td>
                    <td>{{ b.starsWon > 0 ? b.starsWon : '—' }}</td>
                    <td class="hl-b-league">{{ b.leagueType || '—' }}</td>
                    <td class="hl-b-date">{{ formatDate(b.battleDate) }}</td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>

        </ng-container>
      </tbody>
    </table>
  </div>

</div>
